import React, { Component } from 'react';
import { func, arrayOf, shape, string } from 'prop-types';
import { Tooltip } from 'src/components/shared';


class TableRow extends Component {
  state = { selected: false }
  onMouseEnter = () => {
    this.setState({ selected: !this.state.selected })
  }

  render() {
    const { children, selected, tooltip, ...other } = this.props
    const className = `participate-table_cell ${selected ? 'selected' : ''}`

    return (
      <td {...other} className={className}>
        {tooltip ? <Tooltip tooltip={tooltip} >{children}</Tooltip> : children}
      </td>
    )
  }
}


export default class CreativeView extends Component {

  onClick = (rowIndex, columnIndex) => () => {
    if (!columnIndex) return
    const { onClick } = this.props
    if (onClick) onClick(rowIndex, columnIndex)
  }

  render() {
    const { data } = this.props

    return (
      <table className="participate-table">
        <tbody>
          {data.map(({ title }, rowIdx) => (
            <tr key={rowIdx}>
              <TableRow> {title} </TableRow>
              {}
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
}

CreativeView.propTypes = {
  data: arrayOf(shape({
    id: string.isRequired,
    title: string.isRequired,
  })),
  onClick: func,
};

CreativeView.defaultProps = {
  data: [],
  onClick: null
};
